import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteIscFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='ISC' htmlFor='input-importeIsc' md={12} />
      <Col md={12}>
        <Form.InputNumber id='input-importeIsc' name='input-importeIsc' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteIscFormGroup)
